module.exports = __webpack_public_path__ + "static/img/noticeBar.4e7545c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noticeBar.jpg
// module id = oAbW
// module chunks = 22